module.exports = __webpack_public_path__ + "img/location-item.348f42e3.png";